import Vue from 'vue'
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'

@Module({
  namespaced: true
})
export default class AdminStore extends VuexModule {
  appLoaded = false
  app: KwixeoFramework.App|null = null;
  appModulesLoaded = false
  appModules: KwixeoSubscriptions.DeclaredModules = []
  vatRatesLoaded = false
  vatRates: KwixeoSubscriptions.VatRates = []
  loggedApp: KwixeoFramework.App|null = null;
  urlBeforeAdminLogged: string|null = null

  // CLEAR STORE STATE
  @Action
  clearStore (): void {
    const elements = ['App', 'AppModules', 'VatRates']
    elements.forEach(key => {
      this.context.commit('set' + key, [])
      this.context.commit('set' + key + 'Loaded', false)
    })
  }

  // Sort a list alphabetically
  @Mutation
  orderList (param: { list: KwixeoInterface.GenericObject[]; key: string }): void {
    const key = param.key
    param.list.sort((a, b) => {
      const aKey = a[key].toLowerCase()
      const bKey = b[key].toLowerCase()
      if (aKey < bKey) return -1
      else if (aKey > bKey) return 1
      else return 0
    })
  }

  // Change the loaded state
  @Mutation
  setAppLoaded (state = true): void {
    this.appLoaded = state
  }

  // Set the app
  @Mutation
  setApp (app: KwixeoFramework.App): void {
    this.app = app
  }

  // Load the app from api
  @Action
  async loadApp (force = false): Promise<void> {
    if (!this.appLoaded || force) {
      const response = await Vue.prototype.$kwSubscriptions.axios.get('/admin/app')
      await this.context.commit('setApp', response.data)
      this.context.commit('setAppLoaded')
    }
  }

  // Change the loaded state
  @Mutation
  setAppModulesLoaded (state = true): void {
    this.appModulesLoaded = state
  }

  // Set the app modules
  @Mutation
  setAppModules (modules: KwixeoSubscriptions.DeclaredModules): void {
    this.appModules = modules
  }

  // Add or update an app modules
  @Mutation
  updateModule (module: KwixeoSubscriptions.DeclaredModule): void {
    if (!this.appModulesLoaded) {
      return
    }
    const index = this.appModules.findIndex(val => val.key === module.key)
    if (index >= 0) {
      Vue.set(this.appModules, index, module)
    } else {
      this.appModules.push(module)
    }
  }

  // Load the app modules from api
  @Action
  async loadAppModules (force = false): Promise<void> {
    if (!this.appModulesLoaded || force) {
      const response = await Vue.prototype.$kwSubscriptions.axios.get('/admin/module')
      await this.context.commit('setAppModules', response.data)
      this.context.commit('setAppModulesLoaded')
    }
  }

  // Add or update an app modules
  @Action
  setModule (module: KwixeoSubscriptions.DeclaredModule): void {
    this.context.commit('updateModule', module)
    if (this.appModulesLoaded) {
      this.context.commit('orderList', { list: this.appModules, key: 'name' })
    }
  }

  // Add or update team module datas
  @Action
  setTeamModule (module: KwixeoSubscriptions.DeclaredModule): void {
    const value = this.appModules.find(value => value.key === module.key)
    if (module) {
      this.context.dispatch('setModule', Object.assign(value, module))
    }
  }


  // Change the loaded state
  @Mutation
  setVatRatesLoaded (state = true): void {
    this.vatRatesLoaded = state
  }

  // Set the vat rates
  @Mutation
  setVatRates (vatRates: KwixeoSubscriptions.VatRates): void {
    this.vatRates = vatRates
  }

  // Add or update a vat rate
  @Mutation
  updateVatRate (vatRate: KwixeoSubscriptions.VatRate): void {
    if (!this.vatRatesLoaded) {
      return
    }
    const index = this.vatRates.findIndex(val => val.id === vatRate.id)
    if (index >= 0) {
      Vue.set(this.vatRates, index, vatRate)
    } else {
      this.vatRates.push(vatRate)
    }
  }

  // Remove a vat rate
  @Mutation
  removeVatRate (vatRate: KwixeoSubscriptions.VatRate): void {
    if (!this.vatRatesLoaded) {
      return
    }
    const index = this.vatRates.findIndex(rate => rate.id === vatRate.id)
    if (index >= 0) {
      Vue.delete(this.vatRates, index)
    }
  }

  // Load the vat rates from api
  @Action
  async loadVatRates (force = false): Promise<void> {
    if (!this.vatRatesLoaded || force) {
      const response = await Vue.prototype.$kwSubscriptions.axios.get('/admin/vat_rate?per_page=500&sort=rate')
      await this.context.commit('setVatRates', response.data.data)
      this.context.commit('setVatRatesLoaded')
    }
  }

  // Add or update a vat rate
  @Action
  setVatRate (vatRate: KwixeoSubscriptions.VatRate): void {
    this.context.commit('updateVatRate', vatRate)
    if (this.vatRatesLoaded) {
      this.context.commit('orderList', { list: this.vatRates, key: 'name' })
    }
  }

  // Delete a vat rate
  @Action
  deleteVatRate (vatRate: KwixeoSubscriptions.VatRate): void {
    this.context.commit('removeVatRate', vatRate)
  }


  // Set the vat rates
  @Mutation
  applyLoggedApp (app: KwixeoFramework.App|null): void {
    this.loggedApp = app
  }

  @Action
  setLoggedApp (app: KwixeoFramework.App|null): void {
    this.context.commit('applyLoggedApp', app)
  }

  @Mutation
  applyUrlBeforeAdminLogged (url: string|null): void {
    this.urlBeforeAdminLogged = url
  }

  @Action
  setUrlBeforeAdminLogged (url: string|null): void {
    this.context.commit('applyUrlBeforeAdminLogged', url)
  }
}
